@if (!displayEbmsLinkExp) {
<div class="container">
  <!-- Screen reader announcement for page title -->
  @if (isRegistrationScreenEnabled) {
  <div
    class="visually-hidden"
    tabindex="-1"
    #pageTitleAnnouncer
    role="heading"
    aria-level="1"
  >
    {{ "REGISTRATION" | globalTranslate }}
  </div>
  }
  <nh-alert type="danger" [isOpen]="showErr2">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "ERROR_MSG_2" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  <nh-alert type="danger" [isOpen]="isAlertMessage">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ alertMessage | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  @if (isRegistrationScreenEnabled) {
  <div class="row">
    <div class="col-8">
      <h1 class="page-title" tabindex="-1" #pageTitle>
        {{ "REGISTRATION" | globalTranslate }}
      </h1>
    </div>
  </div>
  }
  <nh-alert type="warning" [isOpen]="ebmsVerify && isRegistrationScreenEnabled">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span
          [innerHTML]="'EBMS_ACCOUNT_CREATIION_NOTE' | globalTranslate"
        ></span>
      </div>
    </div>
  </nh-alert>
  <div class="ps-1 pb-1 hover-red">
    @if (isRegistrationScreenEnabled && !ebmsVerify) {
    <div tabindex="0" class="btn btn-link hover-red" (click)="onPrevious()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.875"
        height="15.75"
        viewBox="0 0 16.875 15.75"
      >
        <g
          id="_icons_arrow-back-outline"
          data-name="⚛️ icons/arrow-back-outline"
          transform="translate(0)"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)"
            fill="#174a7c"
          />
        </g>
      </svg>
      <span class="ps-2">{{ "BACK_TO_PREVIOUS_PAGE" | globalTranslate }}</span>
    </div>
    }
  </div>
  @if (!isRegistrationScreenEnabled) {
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ "SUCCESS" | globalTranslate }}</h1>
    </div>
  </div>
  } @if (isRegistrationScreenEnabled) {
  <div class="bg-custom-register">
    <h2 class="section-header">
      {{ "CREATE_YOUR_ACCOUNT" | globalTranslate }}
    </h2>
    <hr />
    <section>
      <div class="row me-1">
        <div class="col-md-12 ml-1">
          <form [formGroup]="registerAccount">
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  [isRow]="true"
                  label="{{ 'USERNAME' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    id="ra_userName"
                    type="text"
                    name="userName"
                    [attr.aria-label]="'USERNAME' | globalTranslate"
                    formControlName="userName"
                    class="form-control"
                    (focusout)="checkUserNameAvailability()"
                    required
                  />
                </nh-field>
                @if (isUsernameTaken) {
                <div class="validation-feedback">
                  <div>{{ "USERNAME_TAKEN" | globalTranslate }}</div>
                </div>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  [isRow]="true"
                  label="{{ 'FIRST_NAME' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    id="ra_firstName"
                    type="text"
                    name="firstName"
                    [attr.aria-label]="'FIRST_NAME' | globalTranslate"
                    formControlName="firstName"
                    class="form-control"
                    maxlength="45"
                    required
                  />
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  [isRow]="true"
                  label="{{ 'LAST_NAME' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    id="ra_lastName"
                    type="text"
                    name="lastName"
                    [attr.aria-label]="'LAST_NAME' | globalTranslate"
                    formControlName="lastName"
                    minlength="3"
                    class="form-control"
                    required
                  />
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  [isRow]="true"
                  label="{{ 'EMAIL_ADDRESS' | globalTranslate }}"
                  class="label-section"
                >
                  <nh-popover
                    class="ps-1"
                    [content]="'USER_EMAIL_TOOLTIP' | globalTranslate"
                  ></nh-popover>
                  <input
                    id="ra_email"
                    type="email"
                    name="email"
                    [attr.aria-label]="'EMAIL_ADDRESS' | globalTranslate"
                    formControlName="email"
                    class="form-control"
                    (input)="validateEmail($event)"
                    [placeholder]="emailPlaceholder"
                    (focusout)="checkEmailAvailability()"
                    required
                  />
                </nh-field>
                @if (isMailIdTaken && !isMailIdTakenEbms) {
                <div class="validation-feedback">
                  <span class="ml-3 form-text invalid-tooltip d-block">{{
                    "EMAIL_USED" | globalTranslate
                  }}</span>
                </div>
                }
              </div>
            </div>
            <nh-alert type="warning" [isOpen]="isMailIdTakenEbms">
              <div class="row">
                <div class="col-auto icon">
                  <img
                    src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt=""
                  />
                </div>
                <div class="col message">
                  <!-- <span [innerHtml]="'EMAIL_USED_1' | globalTranslate"></span> -->
                  <span
                    >{{ "EMAIL_USED_1" | globalTranslate
                    }}<a href="#" (click)="checkEmailEbmsAccount($event)"
                      ><strong>{{ "HERE" | globalTranslate }}</strong></a
                    >{{ "EMAIL_USED_2" | globalTranslate }}</span
                  >
                </div>
              </div>
            </nh-alert>
            @if (!ebmsVerify) {
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  [isRow]="true"
                  label="{{ 'CONFIRM_EMAIL' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    id="ra_confirmEmail"
                    type="email"
                    name="confirmEmail"
                    [attr.aria-label]="'CONFIRM_EMAIL' | globalTranslate"
                    formControlName="confirmEmail"
                    class="form-control"
                    [placeholder]="emailPlaceholder"
                    (input)="validateEmail($event)"
                  />
                </nh-field>
              </div>
            </div>
            } @if (!ebmsVerify) {
            <p>{{ "VERIFICATION_LINK" | globalTranslate }}</p>
            }
            <h2 class="section-header">
              {{ "CREATE_PASSWORD" | globalTranslate }}
            </h2>
            <hr />
            <p>{{ "PWD_GUIDELINES" | globalTranslate }}</p>
            <br />
            <div class="row">
              <div class="col-md-5">
                <nh-field
                  [isRow]="true"
                  label="{{ 'PASSWORD' | globalTranslate }}"
                  class="label-section"
                >
                  <div class="password-eye">
                    <input
                      id="ra_password"
                      [type]="fieldTextType ? 'text' : 'password'"
                      class="form-control"
                      placeholder="{{ 'ENTER_PASSWORD' | globalTranslate }}"
                      formControlName="password"
                      (input)="validatePassword($event)"
                    />
                    <button
                      type="button"
                      class="eye-icon"
                      tabindex="0"
                      (click)="toggleFieldTextType('password')"
                      (keydown.enter)="toggleFieldTextType('password')"
                      (keydown.space)="
                        $event.preventDefault(); toggleFieldTextType('password')
                      "
                      [attr.aria-label]="
                        fieldTextType
                          ? ('HIDE_PASSWORD' | globalTranslate)
                          : ('SHOW_PASSWORD' | globalTranslate)
                      "
                      [attr.aria-pressed]="fieldTextType"
                    >
                      <img
                        alt=""
                        aria-hidden="true"
                        src="assets/images/Icons/eye-outline-password.svg"
                      />
                    </button>
                  </div>
                </nh-field>
                <nh-field
                  man
                  [isRow]="true"
                  label="{{ 'CONFIRM_PASSWORD' | globalTranslate }}"
                  class="label-section"
                >
                  <div class="password-eye">
                    <input
                      id="ra_confirmPassword"
                      [type]="fieldConfirmPassTextType ? 'text' : 'password'"
                      class="form-control"
                      placeholder="{{ 'CONFIRM_PASSWORD' | globalTranslate }}"
                      [attr.aria-label]="'CONFIRM_PASSWORD' | globalTranslate"
                      formControlName="confirmPassword"
                      (input)="comparePassword($event)"
                    />
                    <button
                      type="button"
                      class="eye-icon"
                      tabindex="0"
                      (click)="toggleFieldTextType('confirmPassword')"
                      (keydown.enter)="toggleFieldTextType('confirmPassword')"
                      (keydown.space)="
                        $event.preventDefault();
                        toggleFieldTextType('confirmPassword')
                      "
                      [attr.aria-label]="
                        fieldConfirmPassTextType
                          ? ('HIDE_PASSWORD' | globalTranslate)
                          : ('SHOW_PASSWORD' | globalTranslate)
                      "
                      [attr.aria-pressed]="fieldConfirmPassTextType"
                    >
                      <img
                        alt=""
                        aria-hidden="true"
                        src="assets/images/Icons/eye-outline-password.svg"
                      />
                    </button>
                  </div>
                </nh-field>
              </div>
              <div class="col-md-7">
                <div class="password-guide">
                  <div class="password-header">
                    <span>{{ "PWD_GUIDE" | globalTranslate }}</span>
                    <hr />
                  </div>
                  <ul>
                    @if (passwordRuleLen) {
                    <li class="password-rules-valid">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden">{{
                            "PASSWORD_REQ_MET" | globalTranslate
                          }}</span>
                          {{ "PG_1" | globalTranslate }}
                        </div>
                      </div>
                    </li>
                    } @if (!passwordRuleLen) {
                    <li class="password-rules">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/not met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                            {{ "PG_1_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_1" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (passwordRuleUpp) {
                    <li class="password-rules-valid">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                            {{ "PG_2_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_2" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (!passwordRuleUpp) {
                    <li class="password-rules">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/not met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                            {{ "PG_2_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_2" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (passwordRuleLow) {
                    <li class="password-rules-valid">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                            {{ "PG_3_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_3" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (!passwordRuleLow) {
                    <li class="password-rules">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/not met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                            {{ "PG_3_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_3" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (passwordRuleNum) {
                    <li class="password-rules-valid">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                            {{ "PG_4_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_4" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (!passwordRuleNum) {
                    <li class="password-rules">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/not met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                            {{ "PG_4_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_4" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (passwordRuleSpl) {
                    <li class="password-rules-valid">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_MET" | globalTranslate }}
                            {{ "PG_5_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_5" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    } @if (!passwordRuleSpl) {
                    <li class="password-rules">
                      <div class="row password-guide-style">
                        <img
                          class="col px-0"
                          src="../../../assets/images/not met icon_PWGuidelines.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <span class="visually-hidden"
                            >{{ "PASSWORD_REQ_NOTMET" | globalTranslate }}
                            {{ "PG_5_ADA" | globalTranslate }}</span
                          >
                          <span aria-hidden="true">{{
                            "PG_5" | globalTranslate
                          }}</span>
                        </div>
                      </div>
                    </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
            <br />
            <h2 class="section-header">
              {{ "SELECT_SECURITY_QUESTIONS" | globalTranslate }}
            </h2>
            <hr />
            <p [innerHtml]="'SECURITY_QUES_TEXT' | globalTranslate"></p>
            <br />
            <div class="row">
              <div class="col">
                <nh-field
                  id="ra_question1"
                  [isRow]="true"
                  label="{{ 'Q1' | globalTranslate }}"
                  class="label-section"
                >
                  <select
                    style="max-width: 55.66666667% !important"
                    nhTranslate
                    name="question1"
                    [attr.aria-label]="'Q1' | globalTranslate"
                    formControlName="question1"
                    [items]="questionSet1"
                  ></select>
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  id="ra_answer1"
                  [isRow]="true"
                  label="{{ 'ANSWER' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    type="text"
                    name="answer1"
                    [attr.aria-label]="'ANSWER' | globalTranslate"
                    formControlName="answer1"
                    (input)="answerUpdate(answer2, answer3, answer1)"
                    class="form-control"
                    maxlength="40"
                  />
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <nh-field
                  id="ra_question2"
                  [isRow]="true"
                  label="{{ 'Q2' | globalTranslate }}"
                  class="label-section"
                >
                  <select
                    style="max-width: 55.66666667% !important"
                    nhTranslate
                    name="question2"
                    [attr.aria-label]="'Q2' | globalTranslate"
                    formControlName="question2"
                    [items]="questionSet2"
                  ></select>
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  id="ra_answer2"
                  [isRow]="true"
                  label="{{ 'ANSWER' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    type="text"
                    name="answer2"
                    [attr.aria-label]="'ANSWER' | globalTranslate"
                    formControlName="answer2"
                    (input)="answerUpdate(answer1, answer3, answer2)"
                    class="form-control"
                    maxlength="40"
                  />
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <nh-field
                  id="ra_question3"
                  [isRow]="true"
                  label="{{ 'Q3' | globalTranslate }}"
                  class="label-section"
                >
                  <select
                    style="max-width: 55.66666667% !important"
                    nhTranslate
                    name="question3"
                    [attr.aria-label]="'Q3' | globalTranslate"
                    formControlName="question3"
                    [items]="questionSet3"
                  ></select>
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <nh-field
                  id="ra_answer3"
                  [isRow]="true"
                  label="{{ 'ANSWER' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    type="text"
                    name="answer3"
                    [attr.aria-label]="'ANSWER' | globalTranslate"
                    formControlName="answer3"
                    (input)="answerUpdate(answer1, answer2, answer3)"
                    class="form-control"
                    maxlength="40"
                  />
                </nh-field>
              </div>
            </div>
            @if (isRecaptchaEnabled && loaderReady) {
            <re-captcha
              id="ra_recaptchaReactive"
              (resolved)="resolved($event)"
              formControlName="recaptchaReactive"
              [siteKey]="siteKey"
            >
            </re-captcha>
            }
            <br />
          </form>
        </div>
      </div>
      <div class="row mb-2 ml-1 me-1">
        <button
          id="continue"
          (click)="createAccount()"
          [disabled]="!isFormValid()"
          class="btn btn-secondary col-md-2 offset-md-8"
        >
          {{ "NEXT_BUTTON" | globalTranslate }}
        </button>
      </div>
    </section>
  </div>
  } @if (!isRegistrationScreenEnabled) {
  <div class="card mb-3" style="border: 0px">
    <div class="card-body shadow-sm">
      <h2 class="section-header">
        {{ "REGISTRATION_LINK_SUCC_SUB_TITLE" | globalTranslate }}
      </h2>
      <hr />
      <section>
        <div class="row">
          <div class="col-md-12">
            @if (!ebmsVerify) {
            <p>{{ "ACCOUNT_CREATION" | globalTranslate }}</p>
            } @if (ebmsVerify) {
            <p>{{ "REGISTRATION_LINK_SUCC_BODY_TEXT" | globalTranslate }}</p>
            } @if (isPerfEnv) {
            <div class="pt-1">
              <a class="btn-link" [href]="verfLink" target="_blank">{{
                verfLink
              }}</a>
            </div>
            }
            <div class="pt-1 hover-red comments">
              <a class="btn btn-link hover-red ps-0" [routerLink]="['/signin']">
                <span class="pe-2">{{
                  "BACK_TO_LOGIN" | globalTranslate
                }}</span>
                <nh-exit-svg></nh-exit-svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  }
</div>
} @if (displayEbmsLinkExp) {
<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="page-title">{{ "LINK_EXPRIED" | globalTranslate }}</h2>
    </div>
  </div>
  <div class="card-body shadow-sm card mb-5" style="border: 0px">
    <h2 class="section-header">
      {{ "REGISTRATION_LINK_EXP_SUB_TIILE" | globalTranslate }}
    </h2>
    <hr />
    <section>
      <p
        [innerHTML]="'REGISTRATION_LINK_VERIFIED_PREVIOUSLY' | globalTranslate"
      ></p>
      <div class="pt-1 hover-red comments">
        <a class="btn btn-link hover-red ps-0" [routerLink]="['/signin']">
          <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
          <nh-exit-svg></nh-exit-svg>
        </a>
      </div>
    </section>
  </div>
</div>
}